import has from 'lodash/has'
import get from 'lodash/get'
import * as integrationType from 'constants/integrationType'

export function getProductFromDict (p, productsDict) {
  if (has(p, 'productId')) {
    const product = get(productsDict, p.productId)
    const assets = get(product, 'assets', [])
    if (product) {
      const res = {
        ...p,
        title: product.title,
        productLink: product.productUrl,
        details: {
          available: true,
          title: product.title,
          description: product.description,
          price: +product.price,
          images: assets.map(asset => asset.url),
          options: [],
          defaultOptions: null,
          productUrl: product.productUrl,
          storeIcon: integrationType.NONE
        }
      }
      return res
    } else {
      return null
    }
  } else {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/api/productsDict.js